window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 *
 */

theme.Product = (function () {
	
	var selectors = {
		addToCart: '[data-add-to-cart]',
		addBundle: '[data-add-bundle-product]',
		productQuantity: '[data-product-quantity]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]',
		addToCartErrorContainer: '[data-cart-error]',
		addToCartErrorContainerSticky: '[data-cart-sticky]',
		addToCartErrorContainerHero: '[data-cart-hero]',
		form: '[action="/cart/add"]',
		dropdownBtn: '[data-accordion-btn]',
		dropdownContent: '[data-accordion-content]',
		productSelect: '[data-product-select]',
		productInput: '[data-product-quantity]',
		productQuantityInput: '.Product__QuantityInput',
		rechargeOptionInput: '.rtx_option_radio'
	};
	
	//spoilers
	$(selectors.dropdownBtn).click((e) => {
		const target = e.target;
		
		if ($(target).hasClass('Product__DropdownBtn')) {
			$(target).children('.PlusIcon').toggleClass('PlusIcon--Active');
			slideToggle($(target).parent().find(selectors.dropdownContent));
		} else {
			//slideToggle($(target).parents('.PDPSubscription__Option').find(selectors.dropdownContent), target);
		}
		
		function slideToggle($element, target)  {
			if (!$element.length) {
				var $elementContent = $(target).parents('.PDPSubscription').find(selectors.dropdownContent);
				
				if ($elementContent.attr('aria-hidden') == "false") {
					$elementContent.slideUp();
					$elementContent.attr('aria-hidden', true);
				}
			} else {
				
				if ($element.attr('aria-hidden') == "true") {
					$element.slideDown();
					$element.attr('aria-hidden', false);
				} else {
					$element.slideUp();
					$element.attr('aria-hidden', true);
				}
			}
		}
	});
	
	//quantity
	const syncQuantity = () => {
		$(document).on('change', selectors.productInput, function (e) {
			$(selectors.productInput).val($(e.target).val());
		});
	}
	syncQuantity();
	
	//rating goto scrolling
	$('.Product__Rating').on('click', function () {
		const headerHeight = $('.Header').height();
		$([document.documentElement, document.body]).animate({
			scrollTop: $('.ProductReviews').offset().top - headerHeight
		}, 1000);
	});
	
	//Sticky cart by scroll
	$(document).on('scroll', () => {
		let posY = window.scrollY,
			cartHeight = $('.StickyCart').height();
		const breakpoint = 600;
		
		if (posY >= breakpoint) {
			$('.StickyCart').css({
				'visibility': 'visible',
				'transform': 'translateY(0)'
			});
			$('.Footer').css({
				'margin-bottom': `${cartHeight}px`
			});
		} else {
			$('.StickyCart').css({
				'visibility': 'hidden',
				'transform': 'translateY(100%)'
			});
		}
	});
	
	//select sync
	$('.Product__StickySelector').on('change', (e) => {
		let value = e.target.value;
		$('.Product__HeroSelector').val(value).trigger("change");
	});
	
	$('.Product__HeroSelector').on('change', (e) => {
		let value = e.target.value;
		$('.Product__StickySelector').val(value);
	});
	
	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		var $container = this.$container = $(container);
		var $stickyCart = this.$sticky = $('.StickyCart');
		
		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}
		
		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		
		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};
		
		this.settings = {};
		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
		
		this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
		
		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
			slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
			
			this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
		}
		
		$(document).on('change', $(selectors.productQuantityInput), function () {
			var inputVal = $('.Product__QuantityInput').val();
			
			if (inputVal == '' || inputVal == false || isNaN(inputVal) ) {
				$('.Product__QuantityInput').val(1)
			}
			
			if (!selectors.rechargeOptionInput.length) {
				$('body').trigger(':calculationPrice');
			}
		});
		
		$(selectors.form).on('submit', function (e) {
			e.preventDefault();
			
			if ($(this).hasClass('StickyCart__Wrapper')) {
				$container.find(selectors.addToCart).first().trigger("click");
			} else {
				var _self = $(this),
					addToCartErrorContainer = $(this).find(selectors.addToCartErrorContainer),
					addToCartErrorContainerSticky = $(this).find(selectors.addToCartErrorContainerSticky),
					addToCartErrorContainerHero = $(this).find(selectors.addToCartErrorContainerHero),
					$shades = _self.find('[data-option-available]'),
					productQuantity = $(selectors.productQuantity).first().val(),
					btn = _self.find('[data-add-to-cart]'),
					products = [],
					products_data = [],
					message = theme.strings.addToCart;
				
				if (productQuantity == '' || productQuantity == false) {
					productQuantity = 1;
				}
				
				if (this.hasAttribute('data-bundle')) {
					let _main_bundle_name = _self.find('#_main_bundle_name').val();
					let _main_bundle_link = _self.find('#_main_bundle_link').val();
					let _main_bundle_sku = _self.find('#_main_bundle_sku').val();
					let _bundle_index = '_bundle_index1';
					message = theme.strings.addToBundle;
					
					$shades.each(function () {
						var variant_id = $(this).val();
						products.push(variant_id);
					});

					products.forEach(function (item, index) {

						products_data.push({
							quantity: productQuantity,
							id: item,
							properties: { _bundle_index: index, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
						})
					})

					// products.sort();
					// var current = null;
					// var cnt = 0;
					//
					// for (var i = 0; i < products.length; i++) {
					// 	if (products[i] != current) {
					// 		if (cnt > 0) {
					// 			products_data.push({
					// 				quantity: cnt,
					// 				id: current,
					// 				properties: {_bundle_index: i, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
					// 			})
					// 		}
					// 		current = products[i];
					// 		cnt = productQuantity;
					//
					// 	} else {
					// 		cnt = +cnt + +productQuantity;
					// 	}
					// }
					//
					// if (cnt > 0) {
					// 	products_data.push({
					// 		quantity: cnt,
					// 		id: current,
					// 		properties: {_main_bundle_name, _main_bundle_link, _main_bundle_sku}
					// 	})
					// }
        } else {
          if ($(this).find(".rtx_buy_box").length) {
            let _subscriptio_plan_name = _self
              .find("[data-pdp-subscription-btn]:checked")
              .attr("data-pdp-subscription-btn");
            products_data.push({
              [_self.find('select[name="id"]').attr("name")]: _self
                .find('select[name="id"]')
                .val(),
              [_self.find(".quantity__input").attr("name")]: _self
                .find(".quantity__input")
                .val(),
              [_self.find('select[name="selling_plan"]').attr("name")]: _self
                .find('select[name="selling_plan"]')
                .val(),
              selling_plan: document.querySelector('[name="selling_plan"]')
                .value,
              selling_plan_name: document.querySelector(
                "[data-pdp-subscription-btn]:checked"
              ).data,
              properties: { _subscriptio_plan_name },
            });
          } else {
						products_data.push({
							[_self.find('select[name="id"]').attr('name')]: _self.find('select[name="id"]').val(),
							[_self.find('.quantity__input').attr('name')]: _self.find('.quantity__input').val()
						});
          }
        }
        /*
				} else {
					if ($(this).find('select[name="selling_plan"]').length) {
						let _subscriptio_plan_name = _self.find('[data-subscriptio-plan-value]:checked').attr('data-subscriptio-plan-value');
						
						products_data.push({
							[_self.find('select[name="id"]').attr('name')]: _self.find('select[name="id"]').val(),
							[_self.find('.quantity__input').attr('name')]: _self.find('.quantity__input').val(),
							[_self.find('select[name="selling_plan"]').attr('name')]: _self.find('select[name="selling_plan"]').val(),
							properties: {_subscriptio_plan_name}
						});
					} else {
						products_data.push({
							[_self.find('select[name="id"]').attr('name')]: _self.find('select[name="id"]').val(),
							[_self.find('.quantity__input').attr('name')]: _self.find('.quantity__input').val()
						});
					}
				}
        */
				
				$.ajax({
					url: '/cart/add.js',
					cache: false,
					type: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					},
					data: JSON.stringify({items: products_data}),
					dataType: 'json',
					success: function (response) {
						if (addToCartErrorContainer.length) {
							addToCartErrorContainerHero.slideUp();
						}
						
						setTimeout(function () {
							btn.children(selectors.addToCartText).html(theme.strings.adding);
						}, 300)
						
						setTimeout(function () {
							$('body').trigger(':addToCart');
						}, 1000)
						
						setTimeout(function () {
							btn.children(selectors.addToCartText).html(message);
						}, 1300)
					},
					error: function (error) {
						if (error.status === 422 && addToCartErrorContainer.length) {
							addToCartErrorContainer.text(error.responseJSON.description);
							addToCartErrorContainerHero.slideDown();
							
							addToCartErrorContainerSticky.css({'display': 'block'})
							setTimeout(() => {
								addToCartErrorContainerSticky.css({
									'transform': 'translateX(-50%) translateY(0)',
									'opacity': '1'
								});
							}, 10);
							
							setTimeout(function () {
								// addToCartErrorContainerHero.slideUp();
								addToCartErrorContainerSticky.css({
									'transform': 'translateX(-50%) translateY(100%)',
									'opacity': '0'
								});
								setTimeout(() => addToCartErrorContainerSticky.css({
									'display': 'none',
								}), 100);
							}, 10000)
						}
					}
				});
			}
		});
		
		//----For select a subscription through a custom input
		subscriptionChange()
		
		function subscriptionChange()  {
			if (!selectors.rechargeOptionInput.length) {
				return false
			} else {
				$('[data-pdp-subscription-btn]').on('click', function (e) {
					var valueForSearch = '';
					
					if ($(this).hasClass('PDPSubscription__Option--Type')) {
						valueForSearch = $(this).parent().find('input').attr('data-pdp-subscription-btn');
						$(this).parents('.Product__CartForm').find('['+ valueForSearch + '] input').trigger('click');
					} else {
						valueForSearch = $(this).parent().find('input').attr('data-pdp-subscription-btn');
						$(this).parents('.Product__CartForm').find('.rc_widget__option__plans__dropdown').val(valueForSearch);
					}
				});
			}
		}
		
		//----For change product price in sticky bar
		//changePriceInSticky()
		
		function changePriceInSticky() {
			if (!selectors.rechargeOptionInput.length) {
				return false
			} else {
				$(selectors.rechargeOptionInput).on('change', function (e) {
					let currentPrice = $(this).attr('data-subscription-price');
					$stickyCart.find(selectors.productPrice).html(currentPrice);
				});
			}
		}
	}
	
	Product.prototype = $.extend({}, Product.prototype, {
		
		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function (evt) {
			var variant = evt.variant;
			
			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				$(selectors.priceWrapper, this.$sticky).removeClass('hide');
			} else {
				$(selectors.addToCart, this.$container).attr('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).attr('hide');
				$(selectors.addToCart, this.$sticky).attr('disabled', true);
				$(selectors.addToCartText, this.$sticky).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$sticky).addClass('hide');
				return;
			}
			
			if (variant.available) {
				$(selectors.addToCart, this.$container).attr('disabled', false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
				$(selectors.addToCart, this.$sticky).attr('disabled', false);
				$(selectors.addToCartText, this.$sticky).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).attr('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
				$(selectors.addToCart, this.$sticky).attr('disabled', true);
				$(selectors.addToCartText, this.$sticky).html(theme.strings.soldOut);
			}
		},
		
		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function (evt) {
			var variant = evt.variant;
			
			//Set product quantity field max-quantity
			let variant_quantity = $(this.$container).find(`[data-product-select] option[value="${evt.variant.id}"]`).data('quantity');
			$(selectors.quantityInput).data('quantity', variant_quantity);
			
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
			
			$(selectors.productPrice, this.$container)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
			$(selectors.productPrice, this.$sticky)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
			
			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},
		
		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function (evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
			
			this.$featuredImage.attr('src', sizedImgUrl);
		},
		
		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);
		}
	});
	
	return Product;
})();
theme.Slider = (function () {

  function Slider(container) {
    var $slider = $(container);
    var config = $.parseJSON($slider.attr('data-slick-config'));

    if (config) {
      $slider.slick(
        config
      );
    }

    if ($slider.hasClass('Hero__Slider')) {
      $(document).on('shopify:section:select',  function (e) {
        $slider.slick('unslick');
        $slider.find('.slick-slide').remove()
        $slider = $('.Hero__Slider')

        $slider.slick(
            config
          );
      })
    }
  }
  return Slider;
})();
theme.Header = (function () {

  function HeaderAction(container) {
    var $container = $(container);
    var $header = $container.find('.Header');
    var $icon = $(container).find('.Header__IconBurger');
    var $mobileMenu = $('.Header__NavigationMobile');
    var $pageOverlay = $('.PageOverlay');
    var $removeOpenMenu = $('[data-remove-open]');
    var $subheader = $('.Subheader');

    //----Sticky header
    // $(window).scroll(function () {
    //   if ($(this).scrollTop() > 70) {
    //     $header.addClass("Sticky");
    //     $subheader.addClass("Subheader--Sticky");
    //   } else {
    //     $header.removeClass("Sticky");
    //     $subheader.removeClass("Subheader--Sticky");
    //   }
    // });

    // test

    //----Mobile Mega Menu
    $('.Header__NavigationLinkMobile').on('click', function() {
      let $megaBlock = $(this).find('.Header__OpenBlock');
      let $megaToggle = $(this).find('.Header__NavigationLinkMobile--Toggle');
      if ($megaBlock.hasClass('Block--Open')) {
        $megaBlock.removeClass('Block--Open');
        $megaToggle.text('+');
      } else {
        $megaBlock.addClass('Block--Open');
        $megaToggle.text('-');
      }
    });

    //----Animation burger icon and open menu
    $icon.on('click', function (e) {
      $('body').toggleClass('Open--Menu');
      $pageOverlay.toggleClass('Is-visible');
      if ($('body').hasClass('Open--Menu')) {
        $mobileMenu.attr("aria-hidden","false")
        bodyScrollLock.disableBodyScroll($('#EnableScrollNavigation')[0]);
      } else {
        $mobileMenu.attr("aria-hidden","true")
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    });

    // ----For close menu when push on browser btn back on mobile
   $removeOpenMenu.on('click', function (e) {
      $('body').removeClass('Open--Menu');
      $pageOverlay.removeClass('Is-visible');
      bodyScrollLock.clearAllBodyScrollLocks();
    });

    $(window).on('resize', function () {
      if ($(window).width() > 990) {
        $('body').removeClass('Open--Menu');
        // $pageOverlay.removeClass('Is-visible');
      }
    });

    var $buttonToggle = $(container).find('[data-action="toggle-collapsible"]');

    $buttonToggle.on('click', function (e) {
      e.preventDefault();
      var _$self = $(this);
      var isOpen = _$self.attr('aria-expanded') === 'true';

      if (isOpen) {
        _$self.attr('aria-expanded', false).next().slideUp();
      } else {
        _$self.attr('aria-expanded', true).next().slideDown();
      }
    });
  }

  return HeaderAction;
})();

theme.Newsletter = (function () {

  function Newsletter(container) {
    var $container = $(container);
    var $newsletterInput = $container.find('.Newsletter__Input');
    var $newsletterInputWrapper = $container.find('.Newsletter__InputContainer');
    var klaviyoListId = $container.data('list-id');
    var $btn = $container.find('.Newsletter__InputSubmit');
    var $errorNotValidEmail = $container.find('.Error--NotValidEmail');
    var $form__subscription = $container.find('#prefooter-form__subscription');
    var $form__error = $container.find('#prefooter-form__error');
    var $form__first_subscription = $container.find('#prefooter-form__first-subscription');

    $newsletterInput.on('change keyup', function () {
      var _self = $(this)
      var email = _self.val();

      function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      var chackingValidEmail = validateEmail(email);

      if (!chackingValidEmail) {
        $btn.attr('disabled', true).addClass('disabled');
        $errorNotValidEmail.slideDown();
        $form__subscription.hide();
        $form__error.hide();
        $form__first_subscription.hide();
      } else {
        $btn.attr('disabled', false).removeClass('disabled');
        $errorNotValidEmail.slideUp();
        $form__subscription.hide();
        $form__error.hide();
        $form__first_subscription.hide();
      }
    })

    $btn.on("click", function(e) {
      e.preventDefault();

      var email = $container.find('.Newsletter__Input').val();
      var origin = '';
      var data = {
        'g':  klaviyoListId,
        '$fields': '$source,$email,$consent_method,$consent_form_id,$origin',
        '$list_fields': '',
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        '$source': 'Newsletter subscription',
        '$email': email,
        '$consent_method': 'Klaviyo Form',
        '$origin': origin
      };
      $.ajax({
        method: 'POST',
        url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
        data: data
      }).done(function (response) {
        if (response.success) {
          if (response.data.is_subscribed) {
            $form__subscription.hide();
            $form__error.hide();
            $form__first_subscription.slideDown();
          } else if (!response.data.is_subscribed) {
            $form__first_subscription.hide();
            $form__error.hide();
            $form__subscription.slideDown();
          }
        } else {
          $form__first_subscription.hide();
          $form__subscription.hide();
          $container.find('.Newsletter__Input').val('');
          $form__error.slideDown();
        }
      }).fail(function (err) {
        $form__first_subscription.hide();
        $form__subscription.hide();
        $container.find('.Newsletter__Input').val('');
        $form__error.slideDown();
      });
    });


    //----------------------------
    // $btn.on("click", function(e) {
    //   e.preventDefault();
    //
    //   console.log(listId)
    //
    //   var cusemail = $container.find('.Newsletter__Input').val();
    //   console.log('Newsletter__Input')
    //   var settings = {
    //     "async": true,
    //     "crossDomain": true,
    //     "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    //     "method": "POST",
    //     "headers": {
    //       "content-type": "application/x-www-form-urlencoded",
    //       "cache-control": "no-cache"
    //     },
    //     "data": {
    //       "g": listId,
    //       "email": cusemail,
    //       "$source": "Newsletter form"
    //     }
    //   }
    //
    //   $.ajax(settings).done(function(response) {
    //     $newsletterInputWrapper.css('opacity', '0');
    //     console.log("done")
    //
    //     if (response.data.is_subscribed) {
    //       $success.slideDown();
    //       console.log("response.data.is_subscribed")
    //     } else {
    //       $error.slideUp();
    //       console.log("errors")
    //     }
    //   });
    // })
  }

  return Newsletter;
})();

/**
 * cartDrawer Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the cartDrawer template.
 *
 * @namespace cartDrawer
 */

theme.CartDrawer = (function () {
	document.documentElement.style.setProperty('--drawer-footer-and-header-height', ($('#sidebar-cart .Drawer__Footer').outerHeight() + $('#sidebar-cart .Drawer__CartHeader').outerHeight() + 40) + 'px');

	var selectors = {
		addToCart: '[data-add-to-cart]',
		sideBarCart: '#sidebar-cart',
		openCart: '[data-action="open-cart"]',
		closeCart: '[data-action="close-cart"]',
		tradeSelect: '[data-profession-dropdown]',
		checkoutBtn: '[name="checkout"]',
		checkoutWithDiscount: '[data-checkout-with-discount]',
		quantitySelectors: '[data-action="update-item-quantity"], [data-action="remove-item"]',
		changeQuantity: '.QuantitySelector__CurrentQuantity',
		selectorQuantity: '.QuantitySelector__Quantity',
		qty: '.js-qty__adjust',
		variantSelect: '.CartItem__VariantSelect',
		productQuantityInput: '.Product__QuantityInput',
		cartItem: '.CartItem',
		itemCounts: '.Drawer__FooterInfoItemCounts',
		cartCount: '.CartCount',
		quickAdd: '[data-quick-add]',
		addToCartErrorContainer: '[data-cart-error]',
		form: '[action="/cart/add"]',
		productPrice: '[data-product-price]',
		comparePrice: '[data-compare-price-update-price]',
		containersWithPrice: '[data-for-update-price]'
	};
	
	function cartDrawer(container) {
		this.$container = $(container);
		var options = {
			test: this.$container.find('.Product__Content') || false
		};
		
		$(document).on('click', selectors.quantitySelectors, function (e) {
			updateItemQuantity(e, this)
		});
		
		$(document).on('change', selectors.changeQuantity, function (e) {
			updateItemQuantity(e, this)
		});
		
		function updateItemQuantity(event, target) {
			event.preventDefault();
			
			var quantity = null,
					elementToAnimate = null;
			
			if (target.tagName === 'INPUT') {
				quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
			} else {
				quantity = parseInt(target.getAttribute('data-quantity'));
			}
			
			// If the quantity is 0, then we will animate the product with a removal effect
			if (quantity === 0) {
				elementToAnimate = target.closest(selectors.cartItem);
			}
		
			const id = $(target).data('line-key');
			
			const data = {
				updates: {
					[id]: quantity
				}
			}

			if ($(target).attr('data-bundle-keys')) {
				
				const bundle_keys = $(target).attr('data-bundle-keys').split(', ');
				
				bundle_keys.forEach((item) => {
					data.updates[item] = quantity
				})
			}
			
			$.ajax({
				url: `/cart/update.js`,
				cache: false,
				type: 'post',
				data: data,
				success: function (itemData) {
					renderCart(elementToAnimate);
					//setTimeout(disableQuantityButtons, 800);
				},
				error: function (error) {
					console.log(error);
				}
			});
		}
		
		function disableQuantityButtons() {
			const cartItems = $('.QuantitySelector__CurrentQuantity');
			let data = [];
			
			cartItems.each(function (index, item) {
				const $el = $(this),
						id = $el.data('line-id');
				
				data[id] = (data[id] || 0) + parseInt($el.val());
			});
			
			Object.keys(data).forEach(vid => {
				if (data[vid] >= $(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).attr('max')) {
					$(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).siblings('.QuantitySelector__Button--Plus').addClass('Disabled');
				} else {
					$(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).siblings('.QuantitySelector__Button--Plus').removeClass('Disabled');
				}
			});
		}
		
		function renderCart(elementToAnimate, notRender = false) {
			if (elementToAnimate !== null) {
				$(elementToAnimate).fadeOut();
			}
			
			fetch('/?section_id=cart-drawer' + '&timestamp=' + Date.now(), {
				credentials: 'same-origin',
				method: 'GET'
			}).then(function (content) {
				content.text().then(function (html) {
					var count = parseInt($(html).find(selectors.itemCounts).attr('data-count'));

					if (isNaN(count)) {
						count = 0
					}

					$(selectors.sideBarCart).html($(html).find('.Drawer__Container'));
					$(selectors.cartCount).html(count);
					$('[data-cart-count]').html(count);
					
					document.documentElement.style.setProperty('--drawer-footer-and-header-height', ($('#sidebar-cart .Drawer__Footer').outerHeight() + $('#sidebar-cart .Drawer__CartHeader').outerHeight() + 40) + 'px');
					
					if(!notRender){
						if ($('.Drawer[aria-hidden="true"]').length) {
							var $drawer = $('#sidebar-cart.Drawer[aria-hidden="true"]');
							
							openCartDrawer($drawer);
						} else {
							bodyScrollLock.disableBodyScroll($('#sidebar-cart').find('#EnableScroll')[0]);
							bodyScrollLock.disableBodyScroll($('#sidebar-cart').find('.Drawer__CartList')[0]);
						}
					}
					
					setTimeout(function () {
						checkingHideShowBtn()
					}, 500)
					
				});
			});
		}
		
		$('body').on(':addToCart', function (e) {
			renderCart();
			//setTimeout(disableQuantityButtons, 800);
		});
		
		function openCartDrawer(drawer) {
			var $overlay = $('.PageOverlay');
			
			drawer.attr('aria-hidden', false);
			$overlay.addClass('Is-visible').css("z-index", "17");
			bodyScrollLock.disableBodyScroll($('#EnableScroll')[0]);
			bodyScrollLock.disableBodyScroll($('.Drawer__CartList')[0]);
		}
		
		function closeCartDrawer(drawer, overlay) {
			overlay.removeClass('Is-visible').css("z-index", "11");
			drawer.attr('aria-hidden', true);
			bodyScrollLock.clearAllBodyScrollLocks();
			$('body').attr('style', '')
		}
		
		// ---- Remove cart items which was sold out
		function checkForRemainder() {
			const soldOutItems = [];
			
			$(selectors.changeQuantity).each((index, item) => {
				if($(item).attr('max') <= 0) {
					soldOutItems.push(0);
				} else {
					soldOutItems.push(parseInt($(item).val()));
				}
			});
			
			if(soldOutItems.includes(0)) {
				$.ajax({
					url: '/cart/update.js',
					dataType: 'json',
					type: 'POST',
					data: {updates: soldOutItems},
					success: function (itemData) {
						renderCart($(`${selectors.changeQuantity}[max=0]`).closest(selectors.cartItem), true);
					},
					error: function (error) {
						console.log(error);
					}
				});
			}
		}
		
		$(document).on('click', selectors.openCart, function (e) {
			e.preventDefault();
			
			var $drawer = $('#sidebar-cart.Drawer[aria-hidden="true"]');
			
			openCartDrawer($drawer)
		});
		
		$(document).on('click', selectors.closeCart, function (e) {
			e.preventDefault();
			
			var $drawer = $('#' + $(this).attr('data-drawer-id'));
			var $overlay = $('.PageOverlay');
			
			closeCartDrawer($drawer, $overlay)
		});
		
		$(document).on('click', '.PageOverlay.Is-visible', function () {
			var $drawer = $('.Drawer[aria-hidden="false"]');
			
			if ($('body').hasClass('Open--Menu')) {
				$('body').removeClass('Open--Menu')
			}
			
			closeCartDrawer($drawer, $(this));
		});
		
		$(document).on('click keyup change', selectors.qty, function (e) {
			if (e.type === 'keyup' && e.keyCode !== 13) return;

			e.preventDefault();
			
			var el = $(this),
					qtySelector = el.siblings('.js-qty__num'),
					qty = parseInt(qtySelector.val().replace(/\D/g, ''));

			// Make sure we have a valid integer
			if (!(parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
				qty = 1;
			}
			// Add or subtract from the current quantity
			if (el.hasClass('js-qty__adjust--plus')) {
				// qty = qty + 1;
				qty = (qty >= el.data('quantity')) ? qty : qty + 1;
			} else {
				qty = qty - 1;
				if (qty <= 1) qty = 1;
			}
			
			// Update the input's number
			qtySelector.val(qty).trigger('change');


			if (!$('.PDPSubscription__OptionLabel').length) {
				// Update the price
				calculationPrice()
			}

		});

		function calculationPrice() {
			var productPriceVal = $(selectors.productPrice).data('product-price'),
				qty = $(selectors.productQuantityInput).val(),
				productPriceForChange = $(selectors.containersWithPrice).find(selectors.productPrice),
				priceFoSet = parseInt(productPriceVal) * parseInt(qty),
				comparePrice = $(selectors.containersWithPrice).find(selectors.comparePrice);

			$(productPriceForChange).html(slate.Currency.formatMoney(priceFoSet, theme.moneyFormat));

			if (comparePrice.length) {
				var comparePriceVal = $(selectors.comparePrice).data('compare-price-update-price'),
					comparePriceForChange = $(selectors.containersWithPrice).find(selectors.comparePrice),
					comparePriceFoSet = parseInt(comparePriceVal) * parseInt(qty);

				$(comparePriceForChange).html(slate.Currency.formatMoney(comparePriceFoSet, theme.moneyFormat));
			}
		}

		$('body').on(':calculationPrice', function (e) {
			calculationPrice();
		});

		// All quantity input value change on up/down arrows key press
		$('.js-qty__num').on('keyup', function (e) {
					// On arrow up key press (38)
					if (e.keyCode == 38) {
						$(this).siblings('.js-qty__adjust--plus').trigger('click');
					}
					// On arrow down key press (40)
					if (e.keyCode == 40) {
						$(this).siblings('.js-qty__adjust--minus').trigger('click');
					}
				});

		$(document).on('change keyup', selectors.selectorQuantity, function () {
			var _self = $(this)
			var quantity = parseInt($(this).attr('data-quantity'))
			var val = parseInt($(this).val())
			var elPlus = _self.siblings('.js-qty__adjust--plus');

			if (val >= quantity) {
				_self.val(quantity)
				elPlus.addClass('Disabled')
			} else {
				elPlus.removeClass('Disabled')
			}
		});

		$(document).on('change', selectors.variantSelect, function (e) {
			var _self = $(this);
			var val = _self.val()
			var quantity = parseInt(_self.find('[data-value="' + val + '"]').attr('data-quantity'));
			var input = _self.parents('.CartItem__Actions').find('.QuantitySelector__Quantity');
			var elPlus = _self.parents('.CartItem__Actions').find('.js-qty__adjust--plus');
			var btn = _self.parents('.CartItem__Info').find('[data-quick-add]');
			
			input.attr('data-quantity', quantity);
			btn.attr('data-variant-id', val);
			input.val(1);

			if (elPlus.hasClass('Disabled')) {
				elPlus.removeClass('Disabled')
			}
		});
		
		$(document).on('click', selectors.quickAdd, function (e) {
			e.preventDefault();
			
			var _self = $(this),
					errorContainer = _self.siblings('[data-cart-error]'),
					variant = $(this).attr('data-variant-id'),
					productQuantity = $(this).parents('.CartItem__Info').find('.quantity__input').val(),
					$drawer = $('#quick-view.Drawer'),
					products_data = [],
					products = [],
					message = theme.strings.addToCart;

			if (productQuantity == '' || productQuantity == false || productQuantity == undefined) {
				productQuantity = 1;
			}
			
			//for bundle product
			if (this.hasAttribute('data-add-bundle-product')) {
				var $shades = _self.siblings('[data-select-available]').find('[data-option-available]'),
						_main_bundle_name = _self.parent().find('#_main_bundle_name').val(),
						_main_bundle_link = _self.parent().find('#_main_bundle_link').val(),
						_main_bundle_sku = _self.parent().find('#_main_bundle_sku').val();
						errorContainer = _self.siblings('[data-cart-error]');
						message = theme.strings.addToBundle;

				$shades.each(function () {
					var variant_id = $(this).val();
					products.push(variant_id);
				});

				products.forEach(function (item, index) {

					products_data.push({
						quantity: productQuantity,
						id: item,
						properties: { _bundle_index: index, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
					})
				})
				
				// products.sort();
				//
				// products_data = []
				// var current = null;
				// var cnt = 0;
				//
				// for (var i = 0; i < products.length; i++) {
				// 	if (products[i] != current) {
				// 		if (cnt > 0) {
				// 			products_data.push({
				// 				quantity: cnt,
				// 				id: current,
				// 				properties: {_bundle_index: i, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
				// 			})
				//
				// 			console.log(3)
				// 		}
				// 		current = products[i];
				// 		cnt = 1;
				//
				// 		console.log(2)
				// 	} else {
				// 		cnt++;
				//
				// 		console.log(1)
				// 	}
				// }
				//
				// if (cnt > 0) {
				// 	products_data.push({
				// 		quantity: cnt,
				// 		id: current,
				// 		properties: {_main_bundle_name, _main_bundle_link, _main_bundle_sku}
				// 	})
				//
				// 	console.log(4)
				// }

			} else {
				products_data.push({
					quantity: productQuantity,
					id: variant
				});
			}


			$.ajax({
				url: '/cart/add.js',
				cache: false,
				type: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
				},
				data: JSON.stringify({items: products_data}),
				dataType: 'json',
				success: function () {
					if ($drawer.attr('aria-hidden') === 'false') {
						$drawer.attr('aria-hidden', 'true')
					}
					
					setTimeout(function () {
						_self.html(theme.strings.adding);
					}, 300)
					
					setTimeout(function () {
						renderCart();
					}, 1000)
					
					setTimeout(function () {
					 _self.html(message);
					}, 1300)
				},
				error: function (error) {
					if (error.status === 422 && errorContainer.length) {
						errorContainer.text(error.responseJSON.description);
						errorContainer.slideDown();
						
						setTimeout(function () {
							errorContainer.slideUp();
						}, 10000)
					}
				}
			});
		});
		
		function checkingHideShowBtn() {
			var windowHeight = $(window).height()
			var scrollHeight = $('.Drawer__RecomWrapper[data-scrollable] .Drawer__RecomWrapperInner').outerHeight();
			if (scrollHeight <= windowHeight) {
				$(".Drawer__RecomFooterWrapper").slideUp();
			} else {
				$(".Drawer__RecomFooterWrapper").slideDown();
			}

			$('.Drawer__RecomWrapper').on('scroll', function () {
				if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
					$(".Drawer__RecomFooterWrapper").slideUp();
				} else {
					$(".Drawer__RecomFooterWrapper").slideDown();
				}
			})
		}
		
		$(window).on('resize orientationchange', function () {
			var windowHeight = $(window).height()
			var scrollHeight = $('.Drawer__RecomWrapper[data-scrollable] .Drawer__RecomWrapperInner').outerHeight();

			if ($(window).width() < 767) {
				$(".Drawer__RecomFooterWrapper").css("display", "none");
			} else if (scrollHeight >= windowHeight) {
				$(".Drawer__RecomFooterWrapper").slideDown();
			}
		});

		if (new URLSearchParams(location.search).has('cart')) {
			var urlParams = new URLSearchParams(location.search);

			urlParams.delete('cart');
			history.replaceState(null, null, location.href.replace(location.search, '?' + urlParams));
			$('body').trigger(':addToCart')
		}
		// ---- Tracking events
		function trackingEvents() {
			$(document).on('click', '[data-add-to-cart-ga]', function (e) {
				ga('send', 'event', 'Cart Upsell', $(this).attr('data-add-to-cart-ga').replace(' Cart Upsell', ''));
				dataLayer.push({'event': $(this).attr('data-add-to-cart-ga')});
			});
		}
		
		
		checkForRemainder();
		checkingHideShowBtn();
		trackingEvents();
		//disableQuantityButtons();
	}

	return cartDrawer;
})();

theme.QuickView = (function () {

  var selectors = {
    quickView: '[data-quick-view]',
    closeQuickView: '[data-action="quick-view"]',
    quickViewCheckOut: '[data-quick-view-check-out]',
    addToCartErrorContainer: '[data-cart-error]',
  };

  function quickView() {

    function openDrawer(drawer) {
      var $overlay = $('.PageOverlay');

      drawer.attr('aria-hidden', false);
      $overlay.addClass('Is-visible').css("z-index", "17");
      bodyScrollLock.disableBodyScroll($('.QuickView__Item')[0]);
    }

    function closeCartDrawer(drawer, overlay) {
      overlay.removeClass('Is-visible').css("z-index", "11");
      drawer.attr('aria-hidden', true);
      bodyScrollLock.clearAllBodyScrollLocks();
      $('body').attr('style', '')
    }

    $(document).on('click', selectors.closeQuickView, function (e) {
      e.preventDefault();

      var $drawer = $('#' + $(this).attr('data-drawer-id'));
      var $overlay = $('.PageOverlay');

      closeCartDrawer($drawer, $overlay)
    });

    $(document).on('click', selectors.quickView, function (e) {
      e.preventDefault()

      var url = $(this).data('quick-view');

      $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
          var drawer = $('#quick-view.Drawer');
          var drawerInner = $('.Drawer__QuickViewWrapper');

          drawerInner.html(data);

          setTimeout(function (){
            openDrawer(drawer);
          }, 300)
        }
      });
    })

    $(document).on('click', selectors.quickViewCheckOut, function (e) {
      e.preventDefault();

      var _self = $(this),
        variant = _self.parents('.CartItem__Info').find('[data-quick-add]').attr('data-variant-id'),
        quantity = _self.parents('.CartItem__Info').find('.quantity__input').val(),
        errorContainer = _self.siblings('[data-cart-error]'),
        redirect_url = '/checkout';

      if (quantity == undefined) {
        quantity = 1;
      }
  
      let products_data = [];
      
      //for bundle product
      if (this.hasAttribute('data-add-bundle-product')) {
        var products = [];
        var $shades = _self.siblings('[data-select-available]').find('[data-option-available]');
        errorContainer = _self.siblings('[data-cart-error]');
    
        $shades.each(function () {
          var variant_id = $(this).val();
          products.push(variant_id);
        });
    
        products.sort();
        
        for (var i = 0; i < products.length; i++) {
          products_data.push({
            quantity: quantity,
            id: products[i]
          })
        }
      }else {
        products_data.push({
          quantity: quantity,
          id: variant
        });
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items: products_data},
        dataType: 'json',
        success: function () {
          window.location.href = redirect_url;
        },
        error: function (error) {
          console.log(error, _self, errorContainer);
          if (error.status === 422 && errorContainer.length) {
            errorContainer.text(error.responseJSON.description);
            errorContainer.slideDown();

            setTimeout(function () {
              errorContainer.slideUp();
            }, 10000)
          }
        }
      });
    })
  }

  quickView()
})();
/**
 * blog Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the blog template.
 *
 * @namespace blog
 */

theme.Blog = (function () {
	
	var selectors = {
		subheaderContainer: '.Subheader',
		subheaderLink: '.Subheader__Link',
		subheaderLinkAll: '[data-all-articles]'
	};
	
	function blog() {
		$(selectors.subheaderContainer).on('click', selectors.subheaderLink, (e) => {
			e.preventDefault();
			
			const target = e.target,
				href = $(target).attr('href'),
				hrefAll = $(selectors.subheaderLinkAll).attr('href');

			$.ajax({
				url: href,
				method: 'GET',
				success: function (data) {
					var drawerInner = $('.Blog');

					drawerInner.html(data);
				},
				error: function (error) {
					$.ajax({
						url: hrefAll,
						method: 'GET',
						success: function (data) {
							var drawerInner = $('.Blog');

							drawerInner.html(data);
						}
					});
				}
			});
			
			$(selectors.subheaderLink)
					.removeClass('Subheader__Link--Active')
					.eq($(selectors.subheaderLink).index($(target)))
					.addClass('Subheader__Link--Active');
		});
	}
	
	return blog;
})();
/**
 * collections Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the collections template.
 *
 * @namespace collections
 */

theme.Collections = (function () {

	var selectors = {
		collectionsContainer: '.CollectionProductsContainer',
		subheaderLink: '.Subheader__Link',
		productCard: '.ProductCardWrapper'
	};

	function collections() {
		//prevent fast clicking (Scroll execution queue)
		// let preventMultipleScroll = false;
		
		$(selectors.collectionsContainer).find(selectors.subheaderLink).on('click', (e) => {
			e.preventDefault();
			
			const target = e.target,
					trigger = $(target).attr('data-trigger'),
					headerHeight = $('.Header').height() + $('.Subheader').height();

			$([document.documentElement, document.body]).animate({
				scrollTop: $(`[data-target-subheader="${trigger}"]`).offset().top - headerHeight
			}, 1000);
		});

		var productCard = $('.ProductCardWrapper');

		productCard.on('mouseenter', function (e) {
			$('.ProductCardWrapper[data-active-product]').removeClass('Active');
		});

		productCard.on('mouseleave', function (e) {
			$('.CollectionProducts__Wrapper').each(function() {
				$(this).find('.ProductCardWrapper[data-active-product]').addClass('Active');
			});
		});

		$(selectors.collectionsContainer).find('[data-quick-view]').on('click', function(){
			ga('send', 'event', 'Ecommerce', 'PLP Quick View');
		});

		$(selectors.collectionsContainer).find('[data-quick-add]').on('click', function(){
			ga('send', 'event', 'Ecommerce', 'PLP Add');
		});
	}

	return collections;
})();
theme.EmbedNativeVideo = (function() {
  var selectors = {
    playButton: '.Video--Play',
    poster: '.Video__Image'
  };

  function EmbedNativeVideo(container) {

    this.element = container;
    this.$container = $(container);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));


    this._loadScript().then(this._setupPlayer.bind(this));
  }

  EmbedNativeVideo.prototype = $.extend({}, EmbedNativeVideo.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    _loadScript: function(evt) {
      var _this30 = this;

      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = _this30.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
      });
    },
    onUnload: function () {
      if (this.player) {
        this.player.destroy(); // Both YouTube and Vimeo use the same function name
      }
    },
    _setupPlayer: function () {
      var _this31 = this;

      var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');

      var playerLoadingInterval = setInterval(function () {
        if (_this31.options['videoType'] === 'youtube') {
          if (window.YT && window.YT.Player) {
            elementToInsert = _this31.element.querySelector('.ImageHero__Video');

            _this31.player = new YT.Player(elementToInsert, {
              videoId: _this31.options['videoId'],
              height: '720',
              width: '1280',
              playerVars: {
                disablekb: 0,
                autoplay: 0,
                cc_load_policy: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 0,
                autohide: 0,
                controls: 2,
                branding: 0,
                loop: 1,
                rel: 0,
                fs: 0,
                wmode: 'opaque',
                origin: _this31.options['requestHost']
              },
              events: {
                onReady: _this31._onYouTubeReady.bind(_this31),
                onStateChange: _this31._onYouTubeStateChange.bind(_this31)
              }
            });

            clearInterval(playerLoadingInterval);
          }
        } else {
          if (window.Vimeo) {
            _this31.player = new Vimeo.Player(elementToInsert, {
              id: _this31.options['videoId'],
              muted: false,
              loop: false
            });
          }
          $(selectors.playButton, _this31.$container).on('click', function (e) {
            e.preventDefault();
            _this31.player.play();

            $(this).parents('.shopify-section').addClass('ActiveVideo');

            $(selectors.poster, _this31.$container).fadeOut();
            $(this).fadeOut();
          })
        }
      }, 50);
    },
    _onYouTubeReady: function (event) {
      const _this = this;

      $(selectors.playButton, _this.$container).on('click', function (e) {
        e.preventDefault();

        var enableSound = $(this).data( 'enable-sound' );

        _this.player.playVideo();

        $(this).parents('.shopify-section').addClass('ActiveVideo');
        $(selectors.poster, _this.$container).fadeOut();
        $(this).fadeOut();

        $(this).parents('.Article__Hero').find('.Badge').css({
          'transform': 'translateY(30%) rotate(-1.5deg)',
          'z-index':'0'
        })

        if ( enableSound ) {
          _this.player.mute();
        } else {
          _this.player.unMute();
        }
      })

      $(window).scroll(function() {
        var visible = isInViewport(_this.element);

        if(!visible && _this.player.getPlayerState() === 1) {
          _this.player.pauseVideo();

        }
      })

      function isInViewport(node) {
        var rect = node.getBoundingClientRect()
        return (
          (rect.height > 0 || rect.width > 0) &&
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        )
      }
    },
    _onYouTubeStateChange: function (event) {
      // if (event.data === YT.PlayerState.ENDED) {
      // 	this.player.playVideo();
      // }
    }
  });

  return EmbedNativeVideo;
})();

theme.Faq = (function () {

  function faqAction() {
    var $btnScrollToTop = $('.FAQ__BtnScrollToTop')

    $('.FAQ__ContentListQuestion').on('click', function () {
      var _self = $(this)

      _self.next().slideToggle();
      _self.find('.PlusIcon').toggleClass('PlusIcon--Active')
    });

    $(window).on( 'scroll resize orientationchange' ,function () {
      var _self = $(this)

      if ((_self.scrollTop() > 300 ) && (_self.width() > 767) ) {
        $btnScrollToTop.attr('aria-hidden', false);
      } else {
        $btnScrollToTop.attr('aria-hidden', true);
      }
    });

    $btnScrollToTop.on('click', function () {
      $('html,body').animate({ scrollTop: 0 }, 1000);
    });
  }

  faqAction()
})();
theme.ContactUs = (function () {

  function contactUsAction() {

    $('.ContactUs__ListItemQuestion').on('click', function () {
      var _self = $(this)

      _self.next().slideToggle();
      _self.find('.PlusIcon').toggleClass('PlusIcon--Active')
    });
  }

  contactUsAction()
})();
theme.ProductOutOfStock = (function () {

  function ProductOutOfStock(container) {
    var $container = this.$container = $(container);
    var klaviyoListId = $container.data('list-id');
    var $inputEmail = $container.find('.Product__OutOfStockInput');
    var $btn = $container.find('[data-product-out-of-stock]');

    var $errorNotValidEmail = $container.find('.Error--NotValidEmail');
    var $formSubscription = $container.find('#prefooter-form__subscription');
    var $formError = $container.find('#prefooter-form__error');
    var $formFirstSubscription = $container.find('#prefooter-form__first-subscription');
    var $formEnterEmail = $container.find('#prefooter-form__enter-email');

    $inputEmail.on('change keyup', function () {
      var _self = $(this)
      var email = _self.val();

      function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      var chackingValidEmail = validateEmail(email);

      if (!chackingValidEmail) {
        $btn.attr('disabled', true).addClass('disabled');
        $errorNotValidEmail.slideDown();
        $formSubscription.hide();
        $formError.hide();
        $formFirstSubscription.hide();
        $formEnterEmail.slideUp();
      } else {
        $btn.attr('disabled', false).removeClass('disabled');
        $errorNotValidEmail.slideUp();
        $formSubscription.hide();
        $formError.hide();
        $formFirstSubscription.hide();
        $formEnterEmail.slideUp();
      }
    })

    $btn.on("click", function(e) {
      e.preventDefault();

      var email = $inputEmail.val();
      var origin = '';
      var data = {
        'g':  klaviyoListId,
        '$fields': '$source,$email,$consent_method,$consent_form_id,$origin',
        '$list_fields': '',
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        '$source': 'Chili Crunch - Notify Me!',
        '$email': email,
        '$consent_method': 'Klaviyo Form',
        '$origin': origin
      };

      if (email.length == 0) {
        $formEnterEmail.slideDown();
      }

      if (email.length > 0) {
        $.ajax({
          method: 'POST',
          url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
          data: data
        }).done(function (response) {
          if (response.success) {
            if (response.data.is_subscribed) {
              $formSubscription.hide();
              $formError.hide();
              $formEnterEmail.slideUp();
              $inputEmail.slideUp();
              $btn.slideUp();

              setTimeout(function () {
                $formFirstSubscription.slideDown();
              }, 1200);
            } else if (!response.data.is_subscribed) {
              $formFirstSubscription.hide();
              $formError.hide();
              $formEnterEmail.slideUp();
              $inputEmail.slideUp();
              $btn.slideUp();

              setTimeout(function () {
                $formSubscription.slideDown();
              }, 1200);
            }
          } else {
            $formFirstSubscription.hide();
            $formSubscription.hide();
            $container.find('.Newsletter__Input').val('');
            $formEnterEmail.slideUp();
            $inputEmail.slideUp();

            setTimeout(function () {
              $formError.slideDown();
            }, 1200);
          }
        }).fail(function (err) {
          $formFirstSubscription.hide();
          $formSubscription.hide();
          $container.find('.Newsletter__Input').val('');
          $formEnterEmail.slideUp();
          $inputEmail.slideUp();
          $formError.slideDown();
        });
      }
    });
  }

  return ProductOutOfStock;
})();

theme.ProductSimple = (function () {

  function productSimpleAction() {

    $('.Product__Selector .selection').on('click', function(e) {

      // Update/Toggle 'js-selected'
      $(this).parent().children('.selection').each(function() {
        $(this).removeClass('js-selected');
      });
      $(this).addClass('js-selected');

      // Update '#productSelect'
      let variant = $(this).data('variant-id');
      $(`#productSelect option[selected=selected]`).each(function(){
        $(this).removeAttr('selected');
      })
      $(`#productSelect option[value=${variant}]`).attr('selected','selected');
      $(`#productSelect`).trigger('change');

      // Update Product Title
      /*
      let title = $(this).data('variant-title');
      $('.Product__Heading').text(title);
      */

      // Swap Gallery
      let handle = $(this).data('combined-handle');
      //console.log(`combined-handle: ${handle}`)
      $('.ProductCard__Badges[data-combined-handle]').hide();
      $('.Product__HeroSliderWrapper[data-combined-handle]').hide();
      $('.Product__HeroDots[data-combined-handle]').hide();
      $(`.ProductCard__Badges[data-combined-handle="${handle}"]`).css('display', 'flex');
      $(`.Product__HeroSliderWrapper[data-combined-handle="${handle}"]`).show();
      $(`.Product__HeroDots[data-combined-handle="${handle}"]`).show();
      $('.Product__HeroSliderWrapper[data-combined-handle]').slick('resize');
      $('.Product__HeroSliderWrapper[data-combined-handle]').slick('reinit');
      $('.Product__HeroDots[data-combined-handle]').slick('resize');

      // Update Gallery Badges
      // These are the badges that appear over the gallery.
      let badge_1 =  $(this).data('variant-badge-1');
      let badge_2 =  $(this).data('variant-badge-2');
      if (badge_1.length > 0) {
        $('.Product__HeroBadges .hero-badge-1').text(badge_1);
        $('.Product__HeroBadges .hero-badge-1').show();
      } else {
        $('.Product__HeroBadges .hero-badge-1').hide();
      }
      if (badge_2.length > 0) {
        $('.Product__HeroBadges .hero-badge-2').text(badge_2);
        $('.Product__HeroBadges .hero-badge-2').show();
      } else {
        $('.Product__HeroBadges .hero-badge-2').hide();
      }

      // Update Subscription Badge
      // This badge appears over the subscription selector.
      let badge_sub =  $(this).data('sub-badge');
      if (badge_sub.length > 0) {
        $('.rtx_option .pdp-badge').text(badge_sub);
        $('.rtx_option .pdp-badge').show();
      } else {
        $('.rtx_option .pdp-badge').hide();
      }

      // Update Prices
      let price = $(this).data('variant-price');
      let price_fixed = (price / 100).toFixed(2);
      //console.log(`otp price: ${price}, price_fixed: ${price_fixed} (product-simple)`);
      $('.rtx_option_one_time .rtx_option_price .price').text(`$${price_fixed}`);

      let sub_price = $(this).data('selling-plan-price');
      let sub_price_fixed = (sub_price / 100).toFixed(2);
      //console.log(`sub price: ${sub_price}, price_fixed: ${sub_price_fixed} (product-simple)`);
      $('.rtx_option_sub .rtx_option_price').text(`$${sub_price_fixed}`);

      if ($(`.rtx--active`).hasClass('rtx_option_sub')) {
        // Sub
        $('.ProductPrice span[data-product-price]').attr('data-product-price', sub_price);
        $('.ProductPrice span[data-product-price]').text(`$${sub_price_fixed}`);
      } else {
        // OTP
        $('.ProductPrice span[data-product-price]').attr('data-product-price', price);
        $('.ProductPrice span[data-product-price]').text(`$${price_fixed}`);
      }

      let compare_price = $(this).data('variant-compare-price');
      //console.log(`price: ${price}, compare_price: ${compare_price}`);
      $('.ProductPrice span[data-compare-price]').remove();
      if (compare_price > price) {
        let compare_price_fixed = (compare_price / 100).toFixed(2);
        let $compare = $(`<span data-compare-price="" data-compare-price-update-price="${compare_price}" class="Price--compareAt">$${compare_price_fixed}</span>`);
        $compare.appendTo('.ProductPrice');

        $('.rtx_option_one_time .rtx_option_price .price-comp').text(`$${compare_price_fixed}`);
      } else {
        $('.rtx_option_one_time .rtx_option_price .price-comp').text('');
      }

      // Update RTXN Selection
      let product_id = $('.selection.js-selected').data('product-id');
      let variant_id = $('.selection.js-selected').data('variant-id');
      //let selling_plan_id = $('.selection.js-selected').data('selling-plan-id');

      if ($(`.rtx--active`).hasClass('rtx_option_sub')) {
        $(`.rtx_option_plans`).show();
      } else {
        $(`.rtx_option_plans`).hide();
      }

      $(`.PDPSubscription input[name="selling_plan"]`).attr('id', `selling_plan_${product_id}`);
      //$(`.PDPSubscription input[name="selling_plan"]`).val(selling_plan_id); // this breaks subs
      $(`.PDPSubscription input[name="id"]`).val(variant_id);

      $(`.rtx_buy_box`).attr('id', `rtx_buy_box_${product_id}`);
      $(`.rtx_buy_box`).attr('value', variant_id);

      $('.rtx--active').find('.rtx_option_radio').trigger('click');

    });

    // Subscription Toggles
    $('.rtx_option').on('click', function() {

      let otp_class = 'rtx_option_one_time';
      let sub_class = 'rtx_option_sub';

      if ($(this).hasClass(otp_class) && !$(this).hasClass('rtx--active')) {

        let $radio = $(this).find('.rtx_option_radio');
        //console.log(`otp radio: `, $radio);

        $(`.${sub_class}`).removeClass('rtx--active');
        $(`.${otp_class}`).addClass('rtx--active');

        $radio.trigger('click');

      } else if ($(this).hasClass(sub_class) && !$(this).hasClass('rtx--active')) {

        let $radio = $(this).find('.rtx_option_radio');
        //console.log(`sub radio: `, $radio);

        $(`.${otp_class}`).removeClass('rtx--active');
        $(`.${sub_class}`).addClass('rtx--active');

        $radio.trigger('click');

      }

      // Defunct
      if ($(this).hasClass('selling-plan') && $(this).hasClass('js-selected')) {
        $('.StyledSelect__OptionsWrapper').attr('aria-hidden', 'false');
        $('.StyledSelect__OptionsWrapper').show();
      } else {
        $('.StyledSelect__OptionsWrapper').attr('aria-hidden', 'true');
        $('.StyledSelect__OptionsWrapper').hide();
      }

    });

  }

  productSimpleAction();
})();

theme.FeaturedProducts = (function () {

  function Slider(container) {
    var $sliderMain = $(container).find('.FeaturedProducts__Content');
    var $sliderThumbnails = $(container).find('.FeaturedProducts__Thumbnails');

    var configMain = $.parseJSON($sliderMain.attr('data-slick-config'));
    var configThumbnails = $.parseJSON($sliderThumbnails.attr('data-slick-config'));

    console.log('FeaturedProducts');

      $(document).on('shopify:section:select',  function (e) {
        $sliderMain.slick('unslick');
        $sliderMain.find('.slick-slide').remove()
        $sliderMain = $('.FeaturedProducts__Content')

        $sliderMain.slick(
          configMain
        );

        $sliderThumbnails.slick('unslick');
        $sliderThumbnails.find('.slick-slide').remove()
        $sliderThumbnails = $('.FeaturedProducts__Thumbnails')

        $sliderThumbnails.slick(
          configThumbnails
        );

        console.log('FeaturedProductsSlider');
      })
  }
  return Slider;
})();
theme.Password = (function () {

  function passwordShow() {
    const $passwordLink = $('.password__link');

    $passwordLink.on( "click", function() {
      $(this).parent().next().show();
      $(this).hide();
    });
  }

  // The trick to viewport units on mobile
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  passwordShow();
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.GlobalCssVariables = function() {
  function setValues() {
    var headerHeight = $('header .Header').height();
    var announceHeight = $('header .Header__Announcement').height();

    // set init values
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--announce-height', announceHeight + 'px');
    
    // update size when change orientation
    setTimeout(() => {
      headerHeight = $('.Header').height();

      document.documentElement.style
          .setProperty('--header-height', headerHeight + 'px');
    }, 1000);
  }

  setValues();

  $( window ).on('orientationchange', function () {
    setValues();
  });

  $(window).on('resize', function () {
    setValues();
  });
  
  $(window).on('scroll', function() {
      const headerSize = parseInt($('body').css('--header-height')),
          announceSize = parseInt($('body').css('--announce-height'));
    
      //Make announce NON_Sticky and Header sticky
      if(!$('.Header__Announcement').length || window.pageYOffset >= $('.Header__Announcement').height()) {
        //Make main header fixed after scroll announce
        $('.Header .Header__Container').css({
          'position': 'fixed'
        });
        
        if($('.Subheader').length > 0) {
          $('.Subheader').css({
            'position': 'fixed'
          });
        
          $('main[role="main"]').css({
            'padding-top': `${(headerSize - announceSize) + $('.Subheader').height()}px`
          });
        } else {
          $('main[role="main"]').css({
            'padding-top': `${headerSize - announceSize}px`
          });
        }
      
        //Reduce sticky header x2 if scrolldown
        if(window.pageYOffset >= (headerSize + announceSize)) {
          $('.Header .Header__Container').addClass('Header__Shrink');
          
          $('.Subheader').css({
            'top': `${$('.Header__Shrink').height()}px`
          });
        } else {
          $('.Header .Header__Container').removeClass('Header__Shrink');
          
          $('.Subheader').css({
            'top': `${headerSize - announceSize}px`
          });
        }
      
      } else {
        $('.Header .Header__Container').removeClass('Header__Shrink');
      
        $('.Header .Header__Container').css({
          'position': 'unset'
        });
        
        $('main[role="main"]').attr('style', '');
      
        if($('.Subheader').length > 0) {
          $('.Subheader').css({
            'position': 'initial',
          });
        }
      }
    })
};

theme.bodyScroll = function() {
  if ($('body').hasClass('Open--Menu')) {
    $('body').css({
      'overflow': 'hidden',
      'position': 'sticky'
    });
  } else {
    $('body').css({
      'overflow': 'auto',
      'position': 'relative'
    });
  }
};

theme.init = function () {
  theme.GlobalCssVariables();
  theme.bodyScroll();
};

$(theme.init);

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('slider', theme.Slider);
  sections.register('header', theme.Header);
  sections.register('newsletter', theme.Newsletter);
  sections.register('cart-drawer', theme.CartDrawer);
  sections.register('quick-view', theme.QuickView);
  sections.register('embed-native-video', theme.EmbedNativeVideo);
  sections.register('blog', theme.Blog);
  sections.register('collections', theme.Collections);
  sections.register('faq', theme.Faq);
  sections.register('contact-us', theme.ContactUs);
  sections.register('product-out-of-stock', theme.ProductOutOfStock);
  sections.register('product-simple', theme.ProductSimple);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('password', theme.Password);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});